import { ROW_COUNT } from '../constants/limits';

type GetMultiplierFromRow = (rowIndex: number) => number;

const getMultiplierFromRow: GetMultiplierFromRow = (rowIndex) => (
  Math.abs(rowIndex - ROW_COUNT)
);

export { getMultiplierFromRow };
